export enum EventTypes{
  Select = 1,
  Move,
  Promote,
}




/** WEBPACK FOOTER **
 ** ./client/eventtypes.ts
 **/